/*
 * Navigation Handling, eSearcher >= 3.18
 */
const hasStorage = (type) => {
    let storage;
    try {
        storage = window[type];
        const x = '__storage_test__';
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    } catch (e) {
        return e instanceof DOMException && (// everything except Firefox
                e.code === 22 || // Firefox
                e.code === 1014 || // test name field too, because code might not be present
                // everything except Firefox
                e.name === 'QuotaExceededError' || // Firefox
                e.name === 'NS_ERROR_DOM_QUOTA_REACHED') && // acknowledge QuotaExceededError only if there's something already stored
            (storage && storage.length !== 0);
    }
};

const modern = function () {
    /*
     * Sidebar Handling
     */
    const wrapper = $('#wrapper');
    const wrapperBackdrop = $('#wrapper-backdrop');
    const storageNameSidebarClosed = "Esearcher.navigation.collapsed";
    const storageNameNavDropdownItemContainerIdOpened = "Esearcher.navigation.last_open_target";
    const hasLocalStorage = hasStorage('localStorage');

    const setNavDropdownState = (navDropdownToggle, dropdownOpen, force = false) => {
        if (dropdownOpen) {
            $(navDropdownToggle).removeClass('collapsed');
        } else {
            $(navDropdownToggle).addClass('collapsed');
            const navDropdown = $(navDropdownToggle).parent();
            const navDropdownItemContainer = navDropdown.find('.c-sidebar-nav-dropdown__item-container');
            navDropdownItemContainer.removeClass('show-always');
            if (force) navDropdownItemContainer.removeClass('show');
        }
    }

    const getNavDropdownState = (navDropdownToggle) => {
        return !$(navDropdownToggle).hasClass('collapsed');
    }

    const toggleNavDropdown = (event) => {
        if (wrapper.hasClass('extend')) {
            wrapper.removeClass('extend');
        } else {
            setNavDropdownState(event.target, !getNavDropdownState(event.target));
        }

        if (hasLocalStorage) localStorage.setItem(storageNameSidebarClosed, wrapper.hasClass('extend'));

        const openedNavDropdownItemContainerId = getNavDropdownState(event.target) ? $(event.target).data("target") : null;

        if (hasLocalStorage) localStorage.setItem(storageNameNavDropdownItemContainerIdOpened, openedNavDropdownItemContainerId);
    }

    const closeNavDropdowns = () => {
        $(".c-sidebar-nav-dropdown--toggle:not('.collapsed')").each((index, el) => {
            setNavDropdownState($(el), false, true);
        });
    }

    const closeSidebar = () => {
        closeNavDropdowns();

        wrapper.addClass('extend');
        wrapperBackdrop.removeClass("enabled");

        if (hasLocalStorage) localStorage.setItem(storageNameSidebarClosed, wrapper.hasClass('extend'));

        updateSidebarToggle();
    }

    const toggleSidebar = () => {
        closeNavDropdowns();

        wrapper.toggleClass('extend');
        wrapperBackdrop.toggleClass("enabled");

        if (hasLocalStorage) localStorage.setItem(storageNameSidebarClosed, wrapper.hasClass('extend'));

        updateSidebarToggle();
    }

    const updateSidebarToggle = () => {
        const sidebarToggle = document.getElementById("sidebar-toggle-extended");

        if (!sidebarToggle) return;

        if (wrapper.hasClass('extend')) {
            sidebarToggle.innerHTML = '<i class="eii--fa6-solid--chevron-right"></i>';
        } else {
            sidebarToggle.innerHTML = '<i class="eii--fa6-solid--chevron-left"></i>';
        }
    }

    const bootstrapDetectBreakpoint = () => {
        const breakpointNames = ["xl", "lg", "md", "sm", "xs"];
        let breakpointValues = [];
        for (const breakpointName of breakpointNames) {
            breakpointValues[breakpointName] = window.getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-' + breakpointName);
        }
        let i = breakpointNames.length;
        for (const breakpointName of breakpointNames) {
            i--;
            if (window.matchMedia("(min-width: " + breakpointValues[breakpointName] + ")").matches) {
                return breakpointName;
            }
        }
        return null;
    };

    const currentBreakpoint = bootstrapDetectBreakpoint();

    const forceSidebarClosed = (currentBreakpoint === 'xs' || currentBreakpoint === 'sm' || currentBreakpoint === 'md');
    const isMainWindow = window.self === window.top;
    const isSidebarClosedByDefault = $('.o-sidebar__nav').data('menutoggeldbydefault');

    if (isMainWindow) {
        if (forceSidebarClosed) {
            closeSidebar();
        } else {
            if (hasLocalStorage) {
                const storageSidebarClosed = localStorage.getItem(storageNameSidebarClosed);
                if (!isSidebarClosedByDefault && storageSidebarClosed) {
                    if (wrapper.hasClass('extend') !== JSON.parse(storageSidebarClosed)) {
                        toggleSidebar();
                    }
                }
            }
        }
    }

    $('#sidebar-toggle-extended').on('click', toggleSidebar);
    $('#wrapper-backdrop').on('click', toggleSidebar);
    $('.c-sidebar-nav-dropdown--toggle').on('click', toggleNavDropdown);

    /*
     * Main Content Tab Menu Handling
     */
    $('.tabs-scoped').on('click', '.tabs-scoped-tab-link', (event) => {
        const toggler = $(event.target).parents('.tabs-scoped-wrapper').find('.tabs-scoped-toggler');
        $(toggler.data('target')).collapse('hide');
    })
};

export default modern;
